import type { SenderExternalChannelMode, SenderRunPreset } from '@/api/sender-presets';
import {
	resolveSenderApkDeliveryMethod,
	type SenderApkDeliveryMethod,
} from '@/lib/sender-apk-delivery';
import {
	resolveSenderAudienceFilter,
	type SenderAudienceFilter,
} from '@/lib/sender-audience-filter';
import type { SenderAccountMode, SenderLaunchLocationState } from '@/pages/sender/launch-types';

export function resolveInitialAccountMode(
	state: SenderLaunchLocationState | undefined,
	hasSessions: boolean,
): SenderAccountMode {
	if (state?.accountMode) return state.accountMode;
	if (hasSessions) return 'registry';
	return 'phone';
}

export type LaunchWizardDeliveryFields = {
	apkDeliveryMethod: SenderApkDeliveryMethod;
	caption: string;
	buildId: string;
	externalChannelUrl: string;
	externalChannelMode: SenderExternalChannelMode;
	audienceFilter: SenderAudienceFilter;
	deleteAccountAfterRun: boolean;
};

export function launchDeliveryFieldsFromPreset(preset: SenderRunPreset): LaunchWizardDeliveryFields {
	return {
		apkDeliveryMethod: resolveSenderApkDeliveryMethod(preset.apkDeliveryMethod),
		caption: preset.caption ?? '',
		buildId: preset.buildId ?? '',
		externalChannelUrl: preset.externalChannelUrl ?? '',
		externalChannelMode: preset.externalChannelMode,
		audienceFilter: resolveSenderAudienceFilter(preset.audienceFilter),
		deleteAccountAfterRun: preset.deleteAccountAfterRun,
	};
}
